import { render, staticRenderFns } from "./ItemTesoreriaPage.vue?vue&type=template&id=e2bf3118"
import script from "./ItemTesoreriaPage.js?vue&type=script&lang=js&external"
export * from "./ItemTesoreriaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports